export default "__VITE_ASSET__b954e2db__"